<div class="content">
  <h2 mat-dialog-title class="title">Are you sure you want to close the chat?</h2>
  <button mat-button (click)="closeChat()" class="form-button">Yes</button>
</div>
